import { PROVIDER_CATEGORY, type ProviderId } from '@troia-v3/types';
import type { ChannelResponse } from '@/modules/channels/types';

/**
 * Predicate: a `Channel` é uma conta de email?
 *
 * Usa `PROVIDER_CATEGORY` como source of truth (definido em `@troia-v3/types/providers.ts`).
 * Cobre EMAIL_SMTP, EMAIL_SENDGRID, EMAIL_SES, EMAIL_RESEND e GMAIL_API.
 */
export function isEmailChannel(channel: Pick<ChannelResponse, 'providerId'>): boolean {
  if (!channel.providerId) return false;
  return PROVIDER_CATEGORY[channel.providerId as ProviderId] === 'email';
}
